import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetInventoryTypesInputDto, InventoryTypeCreateDto, InventoryTypeDto, InventoryTypeExcelDownloadDto, InventoryTypeUpdateDto } from '../dtos/inventory-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class InventoryTypeService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: InventoryTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InventoryTypeDto>({
      method: 'POST',
      url: '/api/planning/inventoryTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/inventoryTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/inventoryTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InventoryTypeDto>({
      method: 'GET',
      url: `/api/planning/inventoryTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/inventoryTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetInventoryTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<InventoryTypeDto>>({
      method: 'GET',
      url: '/api/planning/inventoryTypes',
      params: { name: input.name, isRealInventory: input.isRealInventory, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: InventoryTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/inventoryTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, isRealInventory: input.isRealInventory, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InventoryTypeDto[]>({
      method: 'GET',
      url: '/api/planning/inventoryTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: InventoryTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InventoryTypeDto>({
      method: 'PUT',
      url: `/api/planning/inventoryTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}